/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Confirm_Approve_OutInputs */

const vi_sl_detail_confirm_approve_out = /** @type {(inputs: Sl_Detail_Confirm_Approve_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt phiếu xuất này?`)
};

/**

* @param {Sl_Detail_Confirm_Approve_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_confirm_approve_out = /** @type {((inputs?: Sl_Detail_Confirm_Approve_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Confirm_Approve_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_confirm_approve_out(inputs)
});